export default {
  cronData(state) {
    return state.cronData;
  }
};
